import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import HeaderImage from "./components/HeaderImage";
import CompanyCard from "./components/CompanyCard ";
import bannerCompany from "@/assests/img/IMG1.jpeg";
import CompanyService from "@/services/CompanyService";
import PropertiesServices from "@/services/PropertiesService";

import "swiper/css";
import { Divider, Pagination, Select, Spin } from "antd";
import NavigationButtons from "@/pages/home/section/sectionJobByMajor/components/NavigationButtons";
import NavigationButton from "@/pages/home/section/sectionJobNew/components/NavigationButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { LoadingOutlined } from "@ant-design/icons";
import { EmptyComponent } from "@/components/ui/EmptyComponent";


const SectionCompanyVip = () => {
  const companiesPerPage = 6; // Số công ty hiển thị mỗi trang
  const [currentPage, setCurrentPage] = useState(1);
  const [companies, setCompanies] = useState([])
  const [locations, setLocations] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("ALL");
  const [swiperRef, setSwiperRef] = useState(null);
  const [load, setload] = useState(true);


  useEffect(() => {
    setload(true)
    CompanyService.getCompany({ locationId: selectedFilter }).then((res) => {
      setCompanies(res);
      setload(false)
    }).catch((err) => {
      console.error(err);
    });
  }, [selectedFilter]);

  useEffect(() => {
    PropertiesServices.getFilter({ ParentCode: "J003" }).then((res) => {
      setLocations([{
        Code: "ALL",
        Name: `Tất cả Tỉnh thành`
      }, ...res.Data])
    })
  }, []);

  const handleFilterChange = (value) => {
    if (selectedFilter !== value) {
      setSelectedFilter(value);
    }
  };

  // Tính toán vị trí bắt đầu và kết thúc của các công ty trên trang hiện tại
  const indexOfLastCompany = currentPage * companiesPerPage;
  const indexOfFirstCompany = indexOfLastCompany - companiesPerPage;
  const currentCompanies = companies.slice(
    indexOfFirstCompany,
    indexOfLastCompany
  );

  // Chuyển trang
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <section className="p-5 min-h-[500px]">
      {/* Header Image */}
      <div className={"  "}>
        <HeaderImage src={bannerCompany} />
        <Divider className={"w-full uppercase z-10"} style={{ borderColor: "#7cb305" }} orientation={"center"} align={"center"}>
          <h1 className={"text-md lg:text-3xl font-bold text-green-700"}>Thương hiệu lớn tiêu biểu</h1>
          <p className={"text-gray-700 text-xs lg:text-sm"}>Các công ty hàng đầu với dịch vụ chất lượng</p>
        </Divider>
      </div>
      <div className={"flex flex-col md:flex-row gap-6 items-center"}>

        <div className="flex w-full md:hidden h-10">
          <Select className={"w-full h-full"}
            onChange={(e) => handleFilterChange(e)}
            options={locations}
            fieldNames={{ value: "Code", label: "Name" }}
            value={selectedFilter}
          />
        </div>
        <div className={"w-full hidden md:flex items-center gap-4"}>
          <NavigationButton
            direction={"prev"}
            onClick={() => swiperRef?.slidePrev()}
          />
          <div className={"flex-1 overflow-hidden"}>
            <Swiper
              slidesPerView={'auto'}
              onSwiper={setSwiperRef}
              spaceBetween={16}
              navigation={{
                nextEl: "#next",
                prevEl: "#prev",
              }}
              modules={[NavigationButtons]}
              className={"!px-2"}
            >
              {locations.map((option, index) => (
                <SwiperSlide key={index} className={"!w-auto"}>
                  <button
                    className={`px-4 py-2 rounded-full transition-all duration-200 text-sm whitespace-nowrap
                                        ${selectedFilter === option.Code
                        ? "bg-green-600 text-white shadow-lg transform scale-105"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                      } select-none`}
                    onClick={() => handleFilterChange(option.Code)}
                  >
                    {option.Name}
                  </button>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <NavigationButton
            direction={"next"}
            onClick={() => swiperRef?.slideNext()}
          />
        </div>
      </div>

      <div className="min-h-[400px] mt-4 md:mt-8">
        {/* Company Cards Grid */}
        {!load && companies.length === 0 && (
          <div className="w-full h-[400px]  flex items-center justify-center">
            <EmptyComponent description={"Công ty"} />
          </div>
        )}
        {load && (
          <div className="w-full h-[400px]  flex items-center justify-center">
            <Spin indicator={<LoadingOutlined style={{ fontSize: 80 }} spin />} />
          </div>
        )}
        {!load && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {currentCompanies.map((company, i) => (
              <div key={i}><CompanyCard company={company} /></div>
            ))}
          </div>
        )}

        {/* Pagination */}
        {!load && companies.length > companiesPerPage && (
          <div className="mt-8 flex justify-center space-x-4">
            <Pagination
              align="center"
              current={currentPage}
              total={companies.length}
              pageSize={companiesPerPage}
              onChange={paginate}
              showSizeChanger={false}
              showQuickJumper={false}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default SectionCompanyVip;
